/* import __COLOCATED_TEMPLATE__ from './final-transfer-status-modal.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { notEmpty } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { getDisplayNameForSquareupTender } from '@square/dashboard-data/utils/card-brand';
import Money from '@square/dashboard-money/models/money';
let FinalTransferStatusModal = (_dec = notEmpty('instrument.bankAccountSummary.accountNumberSuffix'), _class = class FinalTransferStatusModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "depositInfo", _descriptor3, this);
    _initializerDefineProperty(this, "instrument", _descriptor4, this);
    _initializerDefineProperty(this, "bankAccountSuffix", _descriptor5, this);
    _initializerDefineProperty(this, "bankName", _descriptor6, this);
    _initializerDefineProperty(this, "cardEnding", _descriptor7, this);
    _initializerDefineProperty(this, "unitToken", _descriptor8, this);
    _initializerDefineProperty(this, "errorTitle", _descriptor9, this);
    _initializerDefineProperty(this, "errorDescription", _descriptor10, this);
    _initializerDefineProperty(this, "isBankAccountDeposit", _descriptor11, this);
  }
  get cardBrandName() {
    return this.instrument && this.instrument.cardSummary ? getDisplayNameForSquareupTender(this.instrument.cardSummary.brand, this.intl) : undefined;
  }
  get depositAmount() {
    const amount = Money.fromProto(this.depositInfo?.amount);
    return this.formatter.formatMoney(amount);
  }
  closeModal() {
    this.args.close({
      shouldRefresh: true
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "depositInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.depositInfo;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instrument", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.depositInfo?.destination.instrument;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "bankAccountSuffix", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.instrument?.bankAccountSummary?.accountNumberSuffix;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bankName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.instrument?.bankAccountSummary?.bankName;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cardEnding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.instrument?.cardSummary?.panSuffix;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "unitToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.unitToken;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "errorTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.error?.title;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "errorDescription", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.error?.description;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isBankAccountDeposit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _class);
export { FinalTransferStatusModal as default };